import React, { useEffect, useState } from "react";
import cx from "classnames";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import LOCAL_STORAGE from "../../../../../_redux/localStorage";
import DEFAULT_DATASET_LOGO from "../../../../../assets/images/general/user-photo.svg";

import Logo from "../../../../../components/Logo/Logo";
import TableStatus from "../../../../../data/types/TableStatus";
import AppConfig from "../../../../../AppConfig";
import { saveMarketListing } from "../../../../../_redux/actions/market";

import s from "./ListingDraftHeader.module.scss";

export default function ListingDraftHeader({ listing, onPreview, goBack }) {
	const dispatch = useDispatch();
	const history = useHistory();

	const [isSticky, setIsSticky] = useState(false);
	const stateData = LOCAL_STORAGE.loadState() || {};

	const datasetLogo = stateData.useMocks
		? listing.dataset_logo
		: listing.dataset_logo
		? "data:image/svg+xml;base64," + listing.dataset_logo
		: DEFAULT_DATASET_LOGO;

	// ------------------------------------- METHODS -------------------------------------
	useEffect(() => {
		const handleScrollEvent = () => {
			setIsSticky(window.pageYOffset > 90);
		};

		window.addEventListener("scroll", handleScrollEvent);

		return () => {
			window.removeEventListener("scroll", handleScrollEvent);
		};
	}, []);

	// ------------------------------------- METHODS -------------------------------------
	const onBack = () => {
		// For PREVIEW draft content
		console.debug(typeof goBack);
		
		if (goBack && typeof goBack === "function") {
			goBack();
		} else {
			history.goBack();
		}
	};

	const saveListing = () => {
		// Also forces goBack by setting lsitngDraft to null
		dispatch(saveMarketListing(listing));
	};

	return (
		<div className={cx(s.root, isSticky ? s.sticky : "")}>
			<div className={s.topBar}>
				<div className={s.left}>
					<Button
						className={cx(s.button, "btn-border")}
						color="info"
						onClick={onBack}
					>
						<i className="fa fa-arrow-left" />
						<span>Back</span>
					</Button>
				</div>

				<div className={s.title}>
					<Logo url={"/"} />
				</div>

				<div className={s.right}>
					{listing.status === TableStatus.published && (
						<a
							target="_blank"
							rel="noreferrer"
							href={`${AppConfig.MARKETPLACE_URL}/#/details/${listing.id}`}
						>
							<Button className={cx(s.button, "btn-border")} color="info">
								View On Web
							</Button>
						</a>
					)}

					<Button
						className={cx(s.button, "btn-default", s.dark)}
						color="info"
						onClick={saveListing}
					>
						{listing.status === TableStatus.new ? "Publish" : "Update"}
					</Button>
				</div>
			</div>

			<div className={s.header}>
				{/* LEFT */}
				<div className={s.leftPanel}>
					{datasetLogo && (
						<img src={datasetLogo} alt={"logo"} className={s.logo} />
					)}

					<div className={s.powered}>
						<div className={s.label}>Provided by:</div>
						<div className={s.author}>{listing.author}</div>
					</div>
				</div>

				{/* TITLE */}
				<div className={s.titleContainer}>
					<p className={s.title}>{listing.title}</p>
					<p className={s.description}>{listing.description}</p>

					<div className={s.powered}>
						<span className={s.label}>Provided by:</span>
						<span className={s.author}>{listing.author}</span>
					</div>
				</div>

				{/* BUTTONS */}
				<div className={s.buttonsPanel}>
					{onPreview && (
						<div className={s.previewButton} onClick={onPreview}>
							<Button className={cx(s.button, "btn-border")} color="primary">
								Preview
							</Button>
						</div>
					)}

					<Button className={cx(s.button, "btn-default")} color="primary">
						Download
					</Button>
				</div>
			</div>
		</div>
	);
}
